<template>
    <v-layout row wrap fluid justify-center class="flex-wrap">
        <v-container class="v-col-12 d-flex flex-wrap ga-6">
            <greeting-card :user-name="userStore.getProfile?.firstName" />
            <v-row class="d-md-flex d-block">
                <v-col>
                    <travel-cards :card-type="CARD_NUMBER_LENGTH.NEW" />
                    <travel-cards v-if="smAndDown" :card-type="CARD_NUMBER_LENGTH.OLD" />
                    <buy-ticket />
                    <order-history />
                </v-col>
                <v-col>
                    <travel-cards v-if="!smAndDown" :card-type="CARD_NUMBER_LENGTH.OLD" />
                    <bookings />
                    <issues />
                </v-col>
            </v-row>
        </v-container>
    </v-layout>
</template>

<script setup lang="ts">
import { useUserStore } from '@geta/kolumbus-frontend/features/authentication';
import { useDisplay } from 'vuetify';
import { GreetingCard } from '../features/GreetingCard';
import { BuyTicket } from '@/features/BuyTicket';
import { OrderHistory } from '@/features/OrderHistory';
import { TravelCards } from '@/features/TravelCards/';
import { Issues } from '@/features/Issues';
import { CARD_NUMBER_LENGTH } from '@/constants';
import { Bookings } from '@/features/Bookings';

const userStore = useUserStore();

// TODO: temporary solution, investigate and improve later
const { smAndDown } = useDisplay();
</script>
